import { BaseViewStore } from 'core/stores';
import { ChannelStore } from 'modules/channel/stores';
import { ApplicationStore } from 'platform/application/stores';
import { WarehouseCodesForm } from 'modules/order/forms';
import { action, computed, makeObservable } from 'mobx';
import { channelType, sourceOfChange, viewStoreName } from 'common/constants';
import _ from 'lodash';

class WarehouseCodesViewStore extends BaseViewStore {
	channel;
	warehouses = [];

	form = new WarehouseCodesForm({
		onSuccess: async () => {
			await this.updateChannelWarehouseCodes();
		},
	});

	constructor(rootStore, { modalParams }) {
		super(rootStore);
		makeObservable(this);
		this.modalParams = modalParams;
		this.channelId = modalParams.data.selectedItem ? modalParams.data.selectedItem.id : null;
		this.channelStore = new ChannelStore(rootStore);
		this.applicationStore = new ApplicationStore(rootStore);
		this.initialize();
	}

	@action.bound
	initialize = async () => {
		this.suspend();
		if (this.modalParams.data.store_path === viewStoreName.channelListViewStore || this.modalParams.data.isEdit) {
			this.channel = await this.channelStore.getChannel(this.channelId, {
				embed: ['seller', 'convertWarehouses', 'channelType'],
			});
			this.warehouses = (await this.applicationStore.find({
				search: null,
				rpp: 30,
				page: 1,
				warehouseOnly: true,
				isOrganizationActive: true,
				sellerWarehousesOnlyOrganizationId: this.channel.sellerId,
				includeOnlySellerWarehouses: true,
			})).item;
		} else {
			this.warehouses = this.modalParams.data.warehouses;
		}
		await this.prepareData();
		this.resume();
	};

	@action.bound
	prepareData = async () => {
		if (this.modalParams.data.store_path === viewStoreName.channelListViewStore || this.modalParams.data.isEdit) {
			_.each(this.warehouses, warehouse => {
				const convertWarehouse = _.find(this.channel.convertWarehouses, convertWarehouse => {
					return convertWarehouse.warehouseId === warehouse.id;
				});
				this.form.$('warehouseCodes').add([
					{
						warehouseName: warehouse.identifier,
						name: convertWarehouse ? convertWarehouse.name : null, // Warehouse Code (ConvertWarehouse.Name in the database).
						altName: convertWarehouse ? convertWarehouse.altName : null,
						identifierOnChannel: convertWarehouse ? convertWarehouse.identifierOnChannel : null,
						warehouseId: warehouse.id,
						channelId: this.channel.id,
					},
				]);
			});
		} else {
			_.each(this.modalParams.data.convertWarehouses, convertWarehouse => {
				this.form.$('warehouseCodes').add([
					{
						warehouseName: convertWarehouse.warehouseName,
						name: convertWarehouse.name, // Warehouse Code (ConvertWarehouse.Name in the database).
						altName: convertWarehouse.altName,
						warehouseId: convertWarehouse.warehouseId,
						identifierOnChannel: convertWarehouse.identifierOnChannel,
					},
				]);
			});
		}
	};

	shouldRender = channelType => {
		const { isEdit, store_path, channelTypeDropdownStore } = this.modalParams.data;
		if (store_path === viewStoreName.channelListViewStore || isEdit) {
			return this.channel && this.channel.channelType.name === channelType;
		} else {
			return _.get(channelTypeDropdownStore, 'value.label') === channelType;
		}
	};

	@action.bound
	updateChannelWarehouseCodes = async () => {
		this.suspend();
		try {
			const { warehouseCodes } = this.form.values();
			if (this.modalParams.data.store_path === viewStoreName.channelListViewStore || this.modalParams.data.isEdit) {
				await this.channelStore.updateChannelWarehouseCodes(
					{
						channelId: this.channel.id,
						convertWarehouses: warehouseCodes,
					},
					this.modalParams.data.store_path === 'channelListViewStore'
						? sourceOfChange.channelListUpdatelWarehouseCodes
						: sourceOfChange.channelEditUpdateWarehouseCodes
				);
				this.rootStore.notificationStore.success(['WAREHOUSECODES.SUCCESS', { channelName: this.channel.name }]);
			} else {
				this.modalParams.data.convertWarehouses = warehouseCodes;
				this.rootStore.notificationStore.success(['WAREHOUSECODES.UPDATED']);
			}
			this.modalParams.success();
		} catch (err) {
			if (err.data && err.data.message) {
				this.rootStore.notificationStore.error([err.data.message]);
			} else {
				this.rootStore.notificationStore.error(['WAREHOUSECODES.ERROR', { channelName: this.channel.name }]);
			}
		}
		this.resume();
	};
}

export default WarehouseCodesViewStore;



// WEBPACK FOOTER //
// ./src/modules/channel/stores/WarehouseCodesViewStore.js